module.exports = false;



//////////////////
// WEBPACK FOOTER
// /var/www/dnata-cerf-front-end/releases/20200326161233/~/core-js/modules/_library.js
// module id = KGrn
// module chunks = 1